import React from 'react'
import classNames from 'classnames';

import CheckBox from './../PageLayout/CheckBox';

const formField = ({input, label, type, disabled, meta: {touched, error}}) => {
  return (
    <div>
      <div className={classNames("new-account-text-box-wrapper", {"field-error": touched && error})}>
          <input {...input} type={type} disabled={disabled} />
      </div>
      <div className="new-account-underline-text">{label}</div>
    </div>);
};

export const hiddenField = ({input}) => {
    return (
      <input type='hidden' {...input} />
    )
};

export const required = value => value && value.length ? undefined : 'Required';

export const requiredWithLength = (min, max) => value => (value && value.length >= min && value.length <= max) ? undefined : 'Required';

export const conditionalRequired = (condition) => condition ? required : () => undefined;

// export const phoneValidator = value => value ? (/^[+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im.test(value) ? undefined : 'Wrong format') : undefined;
export const phoneValidator = value => value ? (/^[+]?[\d-]{10,15}$/im.test(value) ? undefined : 'Wrong format') : undefined;

export const requiredPhoneValidator = value => /^[+]?[+]?[\d-]{10,15}$/im.test(value) ? undefined : 'Required';

export const formCheckBoxField = ({input, labelEnabled, labelDisabled, type, disabled, onChecked}) => {
  return <CheckBox checked={input.value}
                   text={input.value ? (labelEnabled || 'Enabled'): (labelDisabled || 'Disabled')}
                   type={type} disabled={disabled} onChecked={checked => onChecked(input, checked)} />;
};

export const formTextAreaField = ({input, label, disabled, placeholder, meta: {touched, error}}) => {
  return (
      <div className="new-account-lir title">
        <div className="new-account-col title">
          <div>{label}</div>
          <div className={classNames("new-account-text-box-wrapper new-account-text-box-wrapper--textarea", {"field-error": touched && error})}>
            <textarea {...input} disabled={disabled} placeholder={placeholder}>{input.value}</textarea>
          </div>
        </div>
      </div>
    );
};


export default formField;

